export default __webpack_public_path__ + "static/media/734.503bbb76.png";